import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const navLinks = [
  { name: 'Pricing', href: '/pricing' },
  { name: 'Relays', href: '/pricing#relay' },
  { name: 'Servers', href: '/servers' },
  { name: 'FAQ', href: '/faq' },
  { name: 'Partners', href: '/partners' },
];

export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-gray-800/50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <span className="text-xl font-bold text-white">
              IRL<span className="text-cyan-400">Hosting</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? 'text-white'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="https://discord.gg/irltools"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white transition-colors"
            >
              Discord
            </a>
            <a href="https://irlhosting.com/whmcs/index.php?rp=/login">
              <Button
                size="sm"
                className="bg-cyan-500 hover:bg-cyan-400 text-black font-semibold"
              >
                Login
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-400 hover:text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-sm font-medium px-2 py-2 rounded-lg transition-colors ${
                    location.pathname === link.href
                      ? 'text-white bg-gray-800'
                      : 'text-gray-400 hover:text-white hover:bg-gray-800/50'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <hr className="border-gray-800" />
              <a
                href="https://discord.gg/irltools"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-white px-2 py-2"
              >
                Discord
              </a>
              <a href="https://irlhosting.com/whmcs/index.php?rp=/login" onClick={() => setMobileMenuOpen(false)}>
                <Button className="w-full bg-cyan-500 hover:bg-cyan-400 text-black font-semibold">
                  Login
                </Button>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
